export default __webpack_public_path__ + "static/media/07.0bd97675.png";